import React from "react";
import Header from "../Header/Header.jsx";
import Lastreons from "../../../Assets/Lastreons.png";
import style from "./style.module.css";

export default function Vip ({ user }) {

    return (
        <>
            <Header auth={true} user={user}/>
            <div className={style.rootDiv}>
                <div className={style.content}>
                    <div className={style.vip}>
                        <p className={style.vipTitle}>VIP</p>
                        <div className={style.vipInfo}>
                            <div className={style.vipPrice}>
                                <p className={style.yellowVip}>300</p>
                                <img src={Lastreons} alt="Lastreons"/>
                                <p className={style.time}>/month</p>
                            </div>
                            <button>More info</button>
                            <div className={style.vipInfoText}>
                                <p>Chat Prefix: status tag</p>
                                <p>Create Player Head Block - /skull</p>
                                <p>Wear Block as Hat - /hat</p>
                                <p>All VIP`s Discord Channel</p>
                            </div>
                                <div className={style.vipSpace}>
                                    <p>Home Limit: 2 homes - /sethome</p>
                                    <p>Residence Limit: 2 - 100x100 size</p>
                                </div>
                        </div>
                        <button className={style.buy}>BUY</button>
                    </div>
                    <div className={style.extraVip}>
                        <p className={style.extraVipTitle}>EXTRA VIP</p>
                        <div className={style.extraVipInfo}>
                            <div className={style.extraVipPrice}>
                                <p className={style.blueExtraVip}>640</p>
                                <img src={Lastreons} alt="Lastreons"/>
                                <p className={style.time}>/month</p>
                            </div>
                            <button>More info</button>
                            <div className={style.extraVipInfoText}>
                                <p>All VIP benefits +</p>
                                <p>Teleport - /tpa</p>
                                <p>Pets</p>
                                <p>Bonus daily rewards</p>
                                <p>Enderchest - /ec</p>
                            </div>
                                <div className={style.extraVipSpace}>
                                    <p>Home Limit: 3 homes - /sethome</p>
                                    <p>Residence Limit: 3 - 150x150 size</p>
                                </div>
                        </div>
                        <button className={style.buy}>BUY</button>
                    </div>
                    <div className={style.ultimateVip}>
                        <p className={style.ultimateVipTitle}>ULTIMATE VIP</p>
                        <div className={style.ultimateVipInfo}>
                            <div className={style.ultimateVipPrice}>
                                <p className={style.blueUltimateVip}>1280</p>
                                <img src={Lastreons} alt="Lastreons"/>
                                <p className={style.time}>/month</p>
                            </div>
                            <button>More info</button>
                            <div className={style.ultimateVipInfoText}>
                                <p>All VIP and EXTRA VIP benefits +</p>
                                <p>Heal yourself - /heal</p>
                                <p>Allowing - /fly</p>
                                <p>Battlepass</p>
                                <p>Particles - /pp</p>
                            </div>
                                <div className={style.ultimateVipSpace}>
                                    <p>Home Limit: 5 homes - /sethome</p>
                                    <p>Residence Limit: 5 - 200x200 size</p>
                                </div>
                        </div>
                        <button className={style.buy}>BUY</button>
                    </div>
                </div>
            </div>
        </>
    )
}